import api from './../api'

export default {
	/**
	 * Load category
	 */

	async loadCategory({ commit }, taxonomy = 'category') {
		if (!taxonomy) return false
		return await api.getTaxonomy({ taxonomy }).then((res) => {
			if (!res.data[0]) console.warn('taxonomy not found, by path', taxonomy)
			commit('STORE_TAXONOMY_DATA', { data: res.data, taxonomy: taxonomy })
			return res.data
		})
	},

	async getTaxonomy({ getters, dispatch }, taxonomy = 'category') {
		const terms = await getters.storedTaxonomy(taxonomy)
		if (!terms.length) {
			return await dispatch('loadCategory', taxonomy).then((res) => {
				getters.storedTaxonomy(taxonomy)
				return res
			})
		} else return terms
	},

	async getAllServices({ commit }) {
		commit('SET_SERVICES_LOADED')
		const loadArgs = {
			action: 'cached',
			type: 'service',
			limit: 500,
		}
		return await api.getPost(loadArgs).then((res) => {
			if (!res.data.posts[0] && process.env.NODE_ENV === 'development') console.warn('post not found')
			commit('STORE_PAGE_DATA', res.data.posts)
			return res
		})
	},

	/**
	 * Load posts elements
	 */
	getPost({ commit, getters }, data) {
		const router = getters.getCurrentRoute
		if (data && typeof data === 'object') {
			if (!data.type) data.type == 'post'
			return api.getPost(data).then((res) => {
				if (!res.data.posts[0] && process.env.NODE_ENV === 'development') console.warn('post not found')
				commit('STORE_PAGE_DATA', res.data.posts)
				return res
			})
		} else if (router) {
			const type = router.meta.type === 'archive' ? 'page' : router.meta.post_type
			const slug = router.params.name
			const id = !slug ? router.meta.id : ''
			if (!slug && !id) return false
			const all_events = true
			return api.getPost({ type, slug, id, all_events }).then((res) => {
				if (!res.data.posts[0]) console.warn('post not found, by path')
				commit('STORE_PAGE_DATA', res.data.posts)
				return res
			})
		} else {
			console.error('Something went wrong in getPost')
			return null
		}
	},

	loadMenu({ commit }, location) {
		return api.getMenu(location).then((res) => {
			if (!res.data) console.warn('menu not found', location)
			commit('STORE_PAGE_MENU', res.data)
			return res.data
		})
	},
}
